import React from "react";
import {Modal, Button} from "react-bootstrap";
import { Link } from 'react-router-dom';
import { UserContact } from 'models/user-contact';
import { Company } from "models/company";
import RoleSelectList from "../RoleSelectModal/RoleSelectList";

interface IContactsMenuProps {
    isVisible: boolean;
    userContacts: UserContact[];
    companies: Company[];
    hasActiveCustomer: boolean;
    handleMenuHide: () => void;
    handleMenuLogout: () => void;
    handleCustomerChange: (customerId: number, isPerson: boolean) => void;
    onRegister: (isCompany: boolean, company?: Company) => void;
}

export function ContactsMenuModal(props: IContactsMenuProps) {

    return (
        <>
            <Modal
                show={props.isVisible}
                onHide={props.handleMenuHide}
                backdropClassName="menu-modal__backdrop"
                dialogClassName="menu-modal__container"
            >
                <Modal.Body className="pb-0">
                    <RoleSelectList 
                        hasActiveCustomer={props.hasActiveCustomer}
                        contacts={props.userContacts}
                        companies={props.companies}
                        onCustomerChange={props.handleCustomerChange}
                        onRegister={props.onRegister}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex flex-column align-items-start flex-wrap mb-1 pt-0">
                    <div className="u-hr"></div>
                    <Link to='/profiil' onClick={props.handleMenuHide} className="btn btn-sm btn-link d-flex align-items-center">
                        <i className='icon__settings'/>
                        <strong className="ml-2 text-dark u-fs-16">Minu sätted</strong>
                    </Link>                    

                    <Button variant="link" onClick={props.handleMenuLogout} className="btn-sm d-flex align-items-center">
                        <i className='icon__logout'/>
                        <strong className="ml-2 text-dark u-fs-16">Logi välja</strong>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}